var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { useGetNotificationsApi, useSetSeenNotificationApi } from '../../hooks';
import { datesManager, useLanguage } from '../../locale';
import { StaticAdviceId, } from '../../models/notifications.models';
export var useNotificationFacade = function (params) {
    var t = useLanguage()[0];
    var _a = useGetNotificationsApi(params), dataItems = _a.dataItems, isFetching = _a.isFetching, fetchNextPage = _a.fetchNextPage;
    var setSeenNotification = useSetSeenNotificationApi().mutateAsync;
    var onEndReached = React.useCallback(function () {
        return fetchNextPage();
    }, [fetchNextPage]);
    var notifications = React.useMemo(function () {
        return dataItems === null || dataItems === void 0 ? void 0 : dataItems.reduce(function (pv, cv) {
            return __spreadArray(__spreadArray([], cv.items, true), pv, true);
        }, []);
    }, [dataItems]);
    var todayNotifications = React.useMemo(function () {
        return notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (notification) {
            return datesManager().isSame(notification.date, 'd');
        });
    }, [notifications]);
    var staticAdvices = React.useMemo(function () {
        return [
            {
                id: StaticAdviceId.B12Vitamin,
                title: '',
                text: t('planPage.staticAdvice.b12VitaminTitle'),
                description: t('planPage.staticAdvice.b12VitaminDescription'),
                seen: false,
            },
            {
                id: StaticAdviceId.Omega3,
                title: '',
                text: t('planPage.staticAdvice.omega3Title'),
                description: t('planPage.staticAdvice.omega3Description'),
                seen: false,
            },
        ];
    }, [t]);
    var setNotificationSeen = React.useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setSeenNotification({ id: id, seen: true })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [setSeenNotification]);
    var hasMorePages = React.useMemo(function () {
        if ((dataItems === null || dataItems === void 0 ? void 0 : dataItems.length) === 0)
            return true;
        var lastElementIndex = ((dataItems === null || dataItems === void 0 ? void 0 : dataItems.length) || 0) - 1;
        return dataItems === null || dataItems === void 0 ? void 0 : dataItems[lastElementIndex].pagination.hasMore;
    }, [dataItems]);
    return {
        notifications: notifications,
        hasMoreElements: hasMorePages,
        totalNotifications: dataItems === null || dataItems === void 0 ? void 0 : dataItems[0].pagination.total_items,
        onEndReached: onEndReached,
        isFetching: isFetching,
        todayNotifications: todayNotifications,
        setNotificationSeen: setNotificationSeen,
        staticAdvices: staticAdvices,
    };
};
